import React from "react";
import styled from "styled-components";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons/faArrowUpRightFromSquare";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FaArrowUpRightFromSquare = props => (
  <FontAwesomeIcon icon={faArrowUpRightFromSquare} {...props} />
);

export const LinkOutIcon = styled(FaArrowUpRightFromSquare)`
  margin-right: 10px;
`;
